export default __webpack_public_path__ + "static/media/img-contact-mail.ec54011b.svg";